import type { QuotaDocument } from "@glide/common-core/dist/js/Database/quotas";
import { useQuery } from "@tanstack/react-query";
import { getQuotaStateForApp } from "../lib/usage-lib";

const TEN_MINUTES_IN_MILLISECONDS = 10 * 60 * 1000;

export function useQuotaStateForApp(appID: string, enabled: boolean): { quotaStateForApp: QuotaDocument | undefined } {
    const { data } = useQuery(
        ["useQuotaStateForApp", appID],
        async () => {
            return await getQuotaStateForApp(appID);
        },
        {
            enabled,
            refetchInterval: TEN_MINUTES_IN_MILLISECONDS,
            refetchOnWindowFocus: false,
        }
    );

    return { quotaStateForApp: data };
}
